import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  GENERATE_REPORT_REQUEST,
  SET_TOAST,
  GENERATE_REPORT_ERROR,
  GENERATE_REPORT_SUCCESS,
  CHECK_REPORT_REQUEST
} from "../../actions";
import {ToastType} from "../../../utils/interfaces";

const ACTIVE_PARAM = 'statuses=ACTIVE&statuses=NOT_ACTIVATED&statuses=PLANNED';
const FINISHED_PARAM = 'statuses=FINISHED';
const ALL_PARAM = `${FINISHED_PARAM}&${ACTIVE_PARAM}`;

const getParam = (tab: 'ALL' | 'FINISHED' | 'ACTIVE'): string => {
  if (tab === 'ACTIVE') {
    return ACTIVE_PARAM;
  }

  if (tab === 'FINISHED') {
    return FINISHED_PARAM;
  }

  return ALL_PARAM;
}

function* workerGenerateReport({
  payload: { tab },
}: {
  type: string;
  payload: {
    tab: 'ALL' | 'FINISHED' | 'ACTIVE';
  };
}): Generator<any> {
  try {
    const patientsParam = getParam(tab);
    const data: any = yield call(PatientsAPI.initiateReport, patientsParam);

    yield put({
      type: GENERATE_REPORT_SUCCESS,
      payload: { currentReport: data }
    });
    yield put({type: CHECK_REPORT_REQUEST});
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: `Report for ${tab.toLowerCase()} patients is initiated, please wait`,
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    yield put({
      type: GENERATE_REPORT_ERROR,
      payload: { code: error?.response?.status, message: error?.message }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Something went wrong",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherGenerateReport() {
  yield takeLatest(GENERATE_REPORT_REQUEST, workerGenerateReport);
}
